import { create } from 'zustand';

interface ErrorState {
  has403Error: boolean;
  set403Error: (value: boolean) => void;
  clear403Error: () => void;
}

const useErrorState = create<ErrorState>(set => ({
  has403Error: false,
  set403Error: (value: boolean) => set({ has403Error: value }),
  clear403Error: () => set({ has403Error: false }),
}));

export default useErrorState;
